import { render, staticRenderFns } from "./SelectListsOfFriends.vue?vue&type=template&id=3e72b402&scoped=true&"
import script from "./SelectListsOfFriends.vue?vue&type=script&lang=js&"
export * from "./SelectListsOfFriends.vue?vue&type=script&lang=js&"
import style0 from "./SelectListsOfFriends.vue?vue&type=style&index=0&id=3e72b402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72b402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e72b402')) {
      api.createRecord('3e72b402', component.options)
    } else {
      api.reload('3e72b402', component.options)
    }
    module.hot.accept("./SelectListsOfFriends.vue?vue&type=template&id=3e72b402&scoped=true&", function () {
      api.rerender('3e72b402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/Privacy/SelectListsOfFriends.vue"
export default component.exports